import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/layout/basic.vue"),
    redirect: "/home",
    children: [
      // {
      //   path: "/vpp/demand-response/list",
      //   meta: {
      //     activeMenu: "/vpp/demand-response/list",
      //     theme: 'dark theme-dark'
      //   },
      //   // component: () => import(/* webpackChunkName: "vpp" */ "@/views/vpp/index.vue"),
      //   component: () => import(/* webpackChunkName: "vpp" */ "@/views/404/index.vue"),
      // },
      {
        path: 'iframe',
        children: [
          {
            path: 'haihong',
            component: () =>
              import(/* webpackChunkName: "vpp" */ "@/views/iframe/haihong/index.vue"),
          },
        ],
        // component: () =>
        //   import(/* webpackChunkName: "vpp" */ "@/views/iframe/haihong/index.vue"),
      },
      {
        path: "/home",
        meta: {
          theme: "dark theme-dark",
        },
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/home/index.vue"),
      },
      {
        path: "/info",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/info/index.vue"),
      },
      {
        path: "/vpp/:catchAll(.*)",
        meta: {
          activeMenu: "/vpp",
          theme: "dark theme-dark",
        },
        component: () =>
          import(/* webpackChunkName: "vpp" */ "@/views/vpp/index.vue"),
      },
      {
        path: "/ops/:catchAll(.*)",
        meta: {
          activeMenu: "/ops",
          theme: "dark theme-dark",
        },
        component: () =>
          import(/* webpackChunkName: "ops" */ "@/views/ops/index.vue"),
      },
      {
        path: "/uav/:catchAll(.*)",
        meta: {
          activeMenu: "/uav",
          theme: "dark theme-dark",
        },
        component: () =>
          import(/* webpackChunkName: "uav" */ "@/views/uav/index.vue"),
      },

      {
        path: "/debugging/:catchAll(.*)",
        component: () =>
          import(/* webpackChunkName: "debugging" */ "@/views/iot/index.vue"),
      },
      {
        path: "/access/:catchAll(.*)",
        meta: {
          // activeMenu: "/vpp",
          // target: true,
          // theme: 'dark'
        },
        component: () =>
          import(/* webpackChunkName: "vpp" */ "@/views/access/index.vue"),
      },

      {
        path: "/system/:catchAll(.*)",
        meta: {
          activeMenu: "/",
        },
        component: () =>
          import(/* webpackChunkName: "vpp" */ "@/views/system/index.vue"),
      },
      {
        path: "/devices/:catchAll(.*)",
        meta: {
          activeMenu: "/",
        },
        component: () =>
          import(/* webpackChunkName: "vpp" */ "@/views/devices/index.vue"),
      },
           {
        path: "/watch/:catchAll(.*)",
        meta: {
          activeMenu: "/",
        },
        component: () =>
          import(/* webpackChunkName: "vpp" */ "@/views/watch/index.vue"),
      },
       {
        path: "/message/:catchAll(.*)",
        meta: {
          activeMenu: "/",
        },
        component: () =>
          import(/* webpackChunkName: "vpp" */ "@/views/message/index.vue"),
      },
      {
        path: "/park/:catchAll(.*)",
        meta: {
          theme: "dark theme-dark",
        },
        component: () =>
          import(/* webpackChunkName: "vpp" */ "@/views/park/index.vue"),
      },
      {
        path: "/photovoltaics/:catchAll(.*)",
        meta: {
          theme: "dark theme-dark",
        },
        component: () =>
          import(
            /* webpackChunkName: "vpp" */ "@/views/photovoltaics/index.vue"
          ),
      },
      {
        path: "/model/:catchAll(.*)",
        meta: {
          // theme: 'dark theme-dark'
        },
        component: () =>
          import(/* webpackChunkName: "vpp" */ "@/views/model/index.vue"),
      },
      {
        path: "/alarm/query/index",
        meta: {
          theme: "dark theme-dark",
        },
        component: () =>
          import(/* webpackChunkName: "vpp" */ "@/views/alarm/index.vue"),
      },
      {
        path: "/alarm/dashboard/index",
        meta: {
          theme: "dark theme-dark",
        },
        component: () =>
          import(/* webpackChunkName: "vpp" */ "@/views/alarm/index.vue"),
      },
      {
        path: "/alarm/:catchAll(.*)",
        meta: {},
        component: () =>
          import(/* webpackChunkName: "vpp" */ "@/views/alarm/index.vue"),
      },
      {
        path: "/authority/:catchAll(.*)",
        meta: {
          activeMenu: "/",
        },
        component: () =>
          import(/* webpackChunkName: "vpp" */ "@/views/authority/index.vue"),
      },

      {
        path: ":catchAll(.*)",
        meta: {},
        component: () =>
          import(/* webpackChunkName: "vpp" */ "@/views/404/index.vue"),
      },
    ],
  },
  {
    path: "/fullscreen/:catchAll(.*)",
    meta: {
      activeMenu: "/fullscreen",
      target: "_blank",
    },
    component: () =>
      import(
        /* webpackChunkName: "fullscreen" */ "@/views/fullscreen/index.vue"
      ),
  },
  {
    path: "/in",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/in/index.vue"),
  },

  {
    path: "/login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/login/index.vue"),
  },
  {
    path: "/forget",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/forget/index.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
